import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "_flexcol _gap-6",
  role: "list"
}
const _hoisted_2 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_home_section_title = _resolveComponent("home-section-title")
  const _component_project_explorer = _resolveComponent("project-explorer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.exploreSections, (section) => {
      return (_openBlock(), _createElementBlock("div", {
        key: section.key,
        role: "listitem",
        "data-qa": `explore-section:${section.title}`
      }, [
        _createVNode(_component_home_section_title, {
          class: "_mb-1",
          "icon-name": section.icon
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(section.title), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["icon-name"]),
        _createVNode(_component_project_explorer, {
          tags: section.tabs,
          "default-tag-key": section.defaultTagKey,
          source: $options.source
        }, null, 8 /* PROPS */, ["tags", "default-tag-key", "source"])
      ], 8 /* PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}